type VerifiedByAccessKey<T> = T & {
    verifiedByAccessKey: true;
};

const isVerifiedByAccessKey = <T>(item: T): item is VerifiedByAccessKey<T> => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (item as any)?.verifiedByAccessKey === true;
};

export type { VerifiedByAccessKey };
export { isVerifiedByAccessKey };
